import { useMemo } from "react";
import { CalculationPrice } from "Store/priceCalculation/priceCalculationInterfaces";

export const useGetCurrentPrices = ({
  priceFilterValue,
  prices,
}: {
  readonly prices: CalculationPrice[];
  readonly priceFilterValue: string | undefined;
}): {
  yearlyPrice: number;
  fullYearlyPrice: number;
  monthlyPrice: number;
  fullMonthlyPrice: number;
} => {
  return useMemo(() => {
    const selectedPrice: CalculationPrice =
      (priceFilterValue
        ? prices.filter((entry) => entry.value === priceFilterValue)
        : prices)[0] || prices[0];
    const yearlyPrice = Number(selectedPrice.yearlyPricePrecise);
    const fullYearlyPrice = Number(selectedPrice.fullYearlyPricePrecise);
    const monthlyPrice = Number(selectedPrice.monthlyPricePrecise);
    const fullMonthlyPrice = Number(selectedPrice.fullMonthlyPricePrecise);
    return { yearlyPrice, fullYearlyPrice, monthlyPrice, fullMonthlyPrice };
  }, [priceFilterValue, prices]);
};
